import { createMuiTheme } from '@material-ui/core';

export const theme = createMuiTheme({
    palette: {
        primary: {
            light: '#FFFFFF',
            main: '#000000',
        },
        secondary: {
            main: '#000000',
            light: '#EEF3F8',
        },
        success: {
            light: '#F7FFF5',
            main: '#7AB15A'
        },
        error: {
            light: '#F6EFEF',
            main: '#B60C0C'
        },
        warning: {
            light: '#FFFDF3',
            main: '#DCBC05'
        },
        text: {
            primary: '#000000',
            secondary: '#808080',
            disabled: '#BFBFBF',
        }
    },
    typography: {
        fontFamily: 'Montserrat',
        h1: {
            fontFamily: 'Montserrat',
            fontWeight: 700,
            fontSize: '6rem',
            lineHeight: '7rem'
        },
        h2: {
            fontFamily: 'Montserrat',
            fontWeight: 700,
            fontSize: '3.75rem',
            lineHeight: '4.5rem'
        },
        h3: {
            fontFamily: 'Montserrat',
            fontWeight: 700,
            fontSize: '3rem',
            lineHeight: '3.5rem'
        },
        h4: {
            fontFamily: 'Montserrat',
            fontWeight: 400,
            fontSize: '2.125rem',
            lineHeight: '2.25rem'
        },
        h5: {
            fontFamily: 'Montserrat',
            fontWeight: 400,
            fontSize: '1.5rem',
            lineHeight: '1.5rem'
        },
        h6: {
            fontFamily: 'Montserrat',
            fontWeight: 700,
            fontSize: '1.25rem',
            lineHeight: '1.5rem'
        },
        subtitle1: {
            fontFamily: 'Montserrat',
            fontWeight: 500,
            fontSize: '1rem',
            lineHeight: '1.5rem'
        },
        subtitle2: {
            fontFamily: 'Montserrat',
            fontWeight: 500,
            fontSize: '0.875rem',
            lineHeight: '1.5rem'
        },
        body1: {
            fontFamily: 'Montserrat',
            fontWeight: 400,
            fontSize: '1rem',
            lineHeight: 1.75
        },
        body2: {
            fontFamily: 'Montserrat',
            fontWeight: 400,
            fontSize: '0.875rem',
            lineHeight: '1.25rem'
        },
        button: {
            fontFamily: 'Montserrat',
            fontWeight: 500,
            fontSize: '1rem',
            lineHeight: '1rem'
        },
        caption: {
            fontFamily: 'Montserrat',
            fontWeight: 400,
            fontSize: '0.75rem',
            lineHeight: '1rem'
        },
        overline: {
            fontFamily: 'Montserrat',
            fontWeight: 500,
            fontSize: '0.625rem',
            lineHeight: '1rem'
        }
    },
});